var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPenTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F2F1FF",
    fillRule: "nonzero",
    cx: 60,
    cy: 60,
    r: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.168 37.297h37.469",
    stroke: "#B2A8FF",
    strokeWidth: 2.162,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.292 60.649c0-12.897 10.412-23.352 23.256-23.352 12.845 0 23.257 10.455 23.257 23.352",
    stroke: "#B2A8FF",
    strokeWidth: 2.162
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#566AB2",
    d: "M58.256 38.595h2.584V36h-2.584z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5233FF",
    strokeWidth: 2.162,
    d: "M58.256 38.595h2.584V36h-2.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#566AB2",
    d: "M35 61.946h2.584V59.35H35z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5233FF",
    strokeWidth: 2.162,
    d: "M35 61.946h2.584V59.35H35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#566AB2",
    d: "M81.513 61.946h2.584V59.35h-2.584z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5233FF",
    strokeWidth: 2.162,
    d: "M81.513 61.946h2.584V59.35h-2.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M68.737 75.97l4.364-9.033-13.618-27.858-13.617 27.858 4.365 9.034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2A8FF",
    d: "M68.737 75.97l4.364-9.033-13.618-27.858-13.617 27.858 4.365 9.034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.41 84H46.394c-.701 0-1.209-.586-1.018-1.176l1.474-7.232c.139-.399.587-.673 1.098-.673h21.908c.51 0 .959.274 1.098.673l1.473 7.232c.191.59-.316 1.176-1.019 1.176M63.425 64.541a3.884 3.884 0 0 1-3.876 3.891 3.885 3.885 0 0 1-3.877-3.891 3.885 3.885 0 0 1 3.877-3.892 3.884 3.884 0 0 1 3.876 3.892z",
    fill: "#5233FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPenTool);
export default __webpack_public_path__ + "static/media/ic_pen_tool.a118ff85ea00c2e4232c00ff30b2210d.svg";
export { ForwardRef as ReactComponent };